import {Typography} from '@mui/material';
type Props = {
  children: JSX.Element;
  [x: string]: any;
};

export const CustomTypography: React.FC<Props> = props => {
  return <Typography {...props}>{props.children}</Typography>;
};
